function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * This file is a modified version of prosemirror-suggestions
 * https://github.com/quartzy/prosemirror-suggestions/blob/master/src/suggestions.js
 */
import { Plugin, PluginKey } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';
export var triggerCharacters = function triggerCharacters(char) {
  return function ($position) {
    var regexp = new RegExp("(?:^)?".concat(char, "[^\\s").concat(char, "]*"), 'g');
    var textFrom = $position.before();
    var textTo = $position.end();
    var text = $position.doc.textBetween(textFrom, textTo, '\0', '\0');
    var match; // eslint-disable-next-line

    while (match = regexp.exec(text)) {
      var prefix = match.input.slice(Math.max(0, match.index - 1), match.index);

      if (!/^[\s\0]?$/.test(prefix)) {
        // eslint-disable-next-line
        continue;
      }

      var from = match.index + $position.start();
      var to = from + match[0].length;

      if (from < $position.pos && to >= $position.pos) {
        return {
          range: {
            from: from,
            to: to
          },
          text: match[0]
        };
      }
    }

    return null;
  };
};
export var suggestionsPlugin = function suggestionsPlugin(_ref) {
  var matcher = _ref.matcher,
      _ref$suggestionClass = _ref.suggestionClass,
      suggestionClass = _ref$suggestionClass === void 0 ? 'prosemirror-mention-node' : _ref$suggestionClass,
      _ref$onEnter = _ref.onEnter,
      onEnter = _ref$onEnter === void 0 ? function () {
    return false;
  } : _ref$onEnter,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return false;
  } : _ref$onChange,
      _ref$onExit = _ref.onExit,
      onExit = _ref$onExit === void 0 ? function () {
    return false;
  } : _ref$onExit,
      _ref$onKeyDown = _ref.onKeyDown,
      onKeyDown = _ref$onKeyDown === void 0 ? function () {
    return false;
  } : _ref$onKeyDown;
  return new Plugin({
    key: new PluginKey('mentions'),
    view: function view() {
      var _this = this;

      return {
        update: function update(view, prevState) {
          var prev = _this.key.getState(prevState);

          var next = _this.key.getState(view.state);

          var moved = prev.active && next.active && prev.range.from !== next.range.from;
          var started = !prev.active && next.active;
          var stopped = prev.active && !next.active;
          var changed = !started && !stopped && prev.text !== next.text;
          if (stopped || moved) onExit({
            view: view,
            range: prev.range,
            text: prev.text
          });
          if (changed && !moved) onChange({
            view: view,
            range: next.range,
            text: next.text
          });
          if (started || moved) onEnter({
            view: view,
            range: next.range,
            text: next.text
          });
        }
      };
    },
    state: {
      init: function init() {
        return {
          active: false,
          range: {},
          text: null
        };
      },
      apply: function apply(tr, prev) {
        var selection = tr.selection;

        var next = _objectSpread({}, prev);

        if (selection.from === selection.to) {
          if (selection.from < prev.range.from || selection.from > prev.range.to) {
            next.active = false;
          }

          var $position = selection.$from;
          var match = matcher($position);

          if (match) {
            next.active = true;
            next.range = match.range;
            next.text = match.text;
          } else {
            next.active = false;
          }
        } else {
          next.active = false;
        }

        if (!next.active) {
          next.range = {};
          next.text = null;
        }

        return next;
      }
    },
    props: {
      handleKeyDown: function handleKeyDown(view, event) {
        var _this$getState = this.getState(view.state),
            active = _this$getState.active;

        if (!active) return false;
        return onKeyDown({
          view: view,
          event: event
        });
      },
      decorations: function decorations(editorState) {
        var _this$getState2 = this.getState(editorState),
            active = _this$getState2.active,
            range = _this$getState2.range;

        if (!active) return null;
        return DecorationSet.create(editorState.doc, [Decoration.inline(range.from, range.to, {
          nodeName: 'span',
          class: suggestionClass
        })]);
      }
    }
  });
};